import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ChartLoader from '../../Loaders/ChartLoader';
import Auth from '../../../shared/Auth';
import CustomLineChart from '../../Custom/CustomLineChart';
import { validateAPEPDCLClient } from '../../../utils/helper';
import { constants } from '../../../shared/constants';
import axios from '../../../utils/axiosClient';

export default class ApparentPowervsTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: {},
      reinitialize: true,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.deviceId, nextProps.deviceId)) {
      this.setState({ reinitialize: true }, () =>
        this.getData(nextProps.deviceId, 1)
      );
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.getData(this.props.deviceId, 1);
  }

  async getData(feederID, numberOfMonths) {
    const current = this;
    const checkToken = await Auth();
    if (checkToken) {
      axios
        .get(`report/totalpowerdemand/${feederID}/${numberOfMonths}`)
        .then((response) => {
          if (response.data.statusCode === 200) {
            current.drawChart(
              response.data.result.totalPowervsTimeData,
              response.data.result.units,
              feederID,
              numberOfMonths
            );
          } else {
            current.drawChart([], '', feederID, numberOfMonths);
          }
        })
        .catch((error) => {
          console.log(error);
          current.drawChart([], '', feederID, numberOfMonths);
        });
    }
  }

  drawChart(data, unit, feederID, numberOfMonths) {
    const totalpower1R = [];
    const totalpower2Y = [];
    const totalpower3B = [];
    data.forEach(async (element) => {
      const tmstmp = Date.parse(element.reportedTime);
      totalpower1R.push([tmstmp, parseFloat(element.totalPower1)]);
      totalpower2Y.push([tmstmp, parseFloat(element.totalPower2)]);
      totalpower3B.push([tmstmp, parseFloat(element.totalPower3)]);
    });

    const self = this;
    const obj = {
      title: this.props.title,
      unit: `Apparent Power (${unit.PowerUnit})`,
      selected: numberOfMonths === 1 ? 0 : 3,
      series: [
        {
          name: validateAPEPDCLClient()
            ? 'Apparent Power-RY'
            : 'Apparent Power-R',
          color: constants.color.RED,
          data: totalpower1R,
        },
        {
          name: validateAPEPDCLClient()
            ? 'Apparent Power-YB'
            : 'Apparent Power-Y',
          color: constants.color.YELLOW,
          data: totalpower2Y,
        },
        {
          name: validateAPEPDCLClient()
            ? 'Apparent Power-BR'
            : 'Apparent Power-B',
          color: constants.color.BLUE,
          data: totalpower3B,
        },
      ],
      evnt: () =>
        self.setState({ reinitialize: true }, () => self.getData(feederID, 6)),
    };

    this.setState({
      options: obj,
      reinitialize: false,
    });
  }

  render() {
    const { options } = this.state;
    if (this.state.reinitialize) {
      return <ChartLoader height="150" width="600" />;
    }

    return <CustomLineChart options={options} />;
  }
}

ApparentPowervsTime.propTypes = {
  deviceId: PropTypes.number.isRequired,
  title: PropTypes.string,
};
